import { app } from "./firebaseConfig";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const auth = getAuth(app);
const db = getFirestore(app);

export interface GameUnlocks {
  name: string;
  email: string;
  lastAccess: number;
  achievements: {
    legendary: { L01: { obtained: boolean, obtainedAt: number } },
    gold: {G02: {obtained: boolean, obtainedAt: number}},
  }
  activate: Activates;
}

export interface Activates {
  [name: string]: {
    activatedDate: string,
    code: string;
  };
}

export async function PostAchievement(achievementCode: string) {
  const param = window.location.search;
  const urlUid = new URLSearchParams(param).get("uid");

  let firebaseUid : string|null = auth.currentUser?.uid || null;

  if (!firebaseUid) {
    firebaseUid = await new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        resolve(user?.uid || null);
      });
      setTimeout(() => {
        unsubscribe();
        resolve(null);
      }, 1000);
    });
  }
  const uidToUse = firebaseUid || urlUid;

  if (uidToUse) {
    await fetch("https://bad-assort.com/api/verify-clear", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: uidToUse,
        timestamp: Date.now(),
        code: achievementCode,
      }),
    });
  }
}
